module.exports = __webpack_public_path__ + "img/kappa-36.6fccc780.png";